export default __webpack_public_path__ + "static/sf.ef47d98a.svg";